import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 53 53",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M52.89 46.787V10.212h-8.138v36.555h-4.068V0H.003v46.787a6.12 6.12 0 0 0 6.1 6.1H46.79a6.121 6.121 0 0 0 6.1-6.1ZM6.61 13.244h26.445v4.407H6.611v-4.407Zm26.445 8.816H6.611v4.407h26.445V22.06ZM6.611 30.873h26.445v4.408H6.611v-4.408Z",
  fill: "#F59600"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };